import React from 'react';
import { Image } from 'react-bootstrap';

export interface Props {
    page: number;
    totalPages: number;
    handlePagination: (page: number) => void;
    classWrapper?: string;
    isDisabled?: boolean;
}

export const Pagination: React.FC<Props> = ({ page, totalPages, handlePagination, classWrapper, isDisabled }) => {
    const MAX_PAGES = 655; // Maximum Modash provided pages
    const clampedTotalPages = Math.min(totalPages, MAX_PAGES);
    const clampedPage = Math.min(page, clampedTotalPages);

    if (clampedTotalPages <= 1) {
        return null;
    }

    const pages: (number | string)[] = [];
    pages.push(1);

    if (clampedPage > 3) {
        pages.push('...');
    }

    for (let i = clampedPage - 1; i <= clampedPage + 1; i++) {
        if (i > 1 && i < clampedTotalPages) {
            pages.push(i);
        }
    }

    if (clampedPage < clampedTotalPages - 2) {
        pages.push('...');
    }

    if (clampedTotalPages > 1) {
        pages.push(clampedTotalPages);
    }

    return (
        <div className="pagination">
            <div className={`paginationWrapper ${classWrapper ?? ''}`}>
                {clampedPage > 1 && (
                    <button
                        disabled={isDisabled}
                        onClick={() => handlePagination(clampedPage - 1)}
                        type="button"
                        className="pageItem sides"
                    >
                        <Image alt="Arrow left pagination image" src="/icons/img-arrow-left.png" />
                    </button>
                )}

                {pages.map((p, idx) =>
                    typeof p === 'number' ? (
                        <button
                            disabled={isDisabled}
                            key={idx}
                            onClick={() => handlePagination(p)}
                            type="button"
                            className={`pageItem ${clampedPage === p ? 'active' : ''}`}
                        >
                            {p}
                        </button>
                    ) : (
                        <div key={idx} className="separator">
                            {p}
                        </div>
                    )
                )}

                {clampedPage < clampedTotalPages && (
                    <button
                        disabled={isDisabled}
                        onClick={() => handlePagination(clampedPage + 1)}
                        type="button"
                        className="pageItem sides"
                    >
                        <Image alt="Arrow right pagination image" src="/icons/img-arrow-right.png" />
                    </button>
                )}
            </div>
        </div>
    );
};
